import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable, OnInit} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {environment} from '../environments/environment';
import {map} from 'rxjs/operators';
import {MatSnackBar} from '@angular/material';

// import {FeaturesTable, PlansTable, Features} from './plans/plans.component';


@Injectable()
export class ConnecttocrudService implements OnInit {
    httpOptions: any;
    // httpOptions: any;
    adminHttpOptions: any;
    appclientHttpOptions: any;
    billingHttpOptions: any;
    templatesHttpOptions: any;
    commonsHttpOptions: any;
    emailTemplateOptions: any;
    settingHttpOptions: any;
    servicesOptions: any;
    accessOptions: any;
    devAccessOptions: any;

    constructor(private _http: HttpClient, private snackBar: MatSnackBar) {
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': localStorage.getItem('partnerKey'),
                'Access-Control-Allow-Origin': '*'
            })
        };
    }

    ngOnInit() {
    }

    errorHandler(error: any): void {
        this.snackBar.open(error.error, 'Error', {
            duration: 5000,
            verticalPosition: 'top',
            horizontalPosition: 'center'
        });
    }

    getHttp() {
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': localStorage.getItem('partnerKey'),
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };
        this.servicesOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': '3fd99a6cdda045e23fb310d0ba17f868',
                'apikey': '6aRV9kJkeD6tiCqtMMINA0ycDOLlSeE5',
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };
        this.adminHttpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': '3fd6b9db619f724c3f834d44247b76c03fb31341c449ef183fed8bcfda90b7bc',
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };
        this.appclientHttpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': '3fd6b9db619f724c3f834d44247b76c03fb31341c449ef183fed8bcfda90b7bc',
                'x-api-key': 'wdwffgefg4122455asdadfvf',
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };
        this.settingHttpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': '3fd99a6cdda045e23fb310d0ba17f868',
                'x-api-key': '6aRV9kJkeD6tiCqtMMINA0ycDOLlSeE5',
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };
        this.billingHttpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': '3fee0e37fef58a553fddddb61efd53e4',
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };

        this.templatesHttpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': '3fe41b41ed1b380a3fef0342c76a973b',
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };

        this.commonsHttpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': '3fe18f9884ea832e3fede1e661740c4a',
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };

        this.emailTemplateOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': '3fe936d53cafa2913fbf2b31b9c0de60',
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };

        this.accessOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': environment.accessPkey,
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };

        this.devAccessOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': environment.devAccessPkey,
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };
    }

    executeApi(item) {
        return this._http.post(environment.apihost + '/v1/api/executor', item, {observe: 'response'});
    }

    executeApiV2(item) {
        return this._http.post(environment.apihost + '/v2/api/executor', item, {observe: 'response'});
    }

    debugBusinessLogic(partner, account, payload) {
        this.getHttp();
        return this._http.post(environment.apihost + '/v1/' + partner + '/' + account + '/business-logic/debugwithfuntions', payload, this.httpOptions);

    }

    getItemswithParameter(version, partner, account, entity, params) {
        this.getHttp();
        let url = environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity;
        if (params && params !== '') {
            url = url + '?' + params;
        }
        if (partner === 'commons') {
            return this._http.get(url, this.commonsHttpOptions).pipe(map(res => res));
        } else if (partner === 'campaign') {
            return this._http.get(url, this.emailTemplateOptions).pipe(map(res => res));
        } else if (partner === 'services') {
            return this._http.get(url, this.servicesOptions).pipe(map(res => res));
        } else if (partner === 'access') {
            return this._http.get(url, this.accessOptions).pipe(map(res => res));
        } else if (partner === 'dev-access') {
            return this._http.get(url, this.devAccessOptions).pipe(map(res => res));
        } else {
            return this._http.get(url, this.httpOptions).pipe(map(res => res));
        }

    }

    getItems(version, partner, account, entity, pagination) {
        this.getHttp();

        switch (partner) {
            case 'commons':
                return this._http.get(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity, this.commonsHttpOptions).pipe(map(res => res));
                break;
            case 'campaign':
                return this._http.get(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity, this.emailTemplateOptions).pipe(map(res => res));
                break;
            case 'services':
                return this._http.get(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity + '?pagination= ' + pagination, this.servicesOptions).pipe(map(res => res));
                break;
            default:
                return this._http.get(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity + '?pagination= ' + pagination, this.httpOptions).pipe(map(res => res));
                break;
        }

        // if (partner === 'commons') {
        //     // const commonsHttpOptions = {
        //     //     headers: new HttpHeaders({
        //     //         'Content-Type': 'application/json',
        //     //         'pkey': '3fe18f9884ea832e3fede1e661740c4a',
        //     //         'Access-Control-Allow-Origin': '*',
        //     //         'observe': 'response'
        //     //     })
        //     // };
        //     return this._http.get(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity, this.commonsHttpOptions).pipe(map(res => res));
        // } else if (partner === 'campaign') {
        //     return this._http.get(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity, this.emailTemplateOptions).pipe(map(res => res));
        // } else if (partner === 'services') {
        //     return this._http.get(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity, this.servicesOptions).pipe(map(res => res));
        // } else {
        //     // this.httpOptions = {
        //     //     headers: new HttpHeaders({
        //     //         'Content-Type': 'application/json',
        //     //         'pkey': localStorage.getItem('partnerKey'),
        //     //         'Access-Control-Allow-Origin': '*'
        //     //     })
        //     // };
        // return this._http.get(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity, this.httpOptions).pipe(map(res => res));
        // }

    }

    getPaginatedData(version, partner, account, entity, offset, limit, fields) {
        this.getHttp();
        return this._http.get(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity + '?pagination=true&offset=' + offset + '&limit=' + limit + '&fields=' + fields, this.httpOptions).pipe(map(res => res));
    }

    getItemsWithParams(version, partner, account, entity, params) {
        this.getHttp();

        let url = environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity + '?pagination= true';
        if (params !== null && params !== undefined) {
            url = url + '&' + params;
        }
        switch (partner) {
            case 'commons':
                return this._http.get(url, this.commonsHttpOptions).pipe(map(res => res));
                break;
            case 'campaign':
                return this._http.get(url, this.emailTemplateOptions).pipe(map(res => res));
                break;
            case 'services':
                return this._http.get(url, this.servicesOptions).pipe(map(res => res));
                break;
            default:
                return this._http.get(url, this.httpOptions).pipe(map(res => res));
                break;
        }
    }

    putItem(version, partner, account, entity, payload, id) {
        this.getHttp();

        const url = environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity + '/' + id;
        switch (partner) {
            case 'commons':
                return this._http.put(url, payload, this.commonsHttpOptions).pipe(map(res => res));
                break;
            case 'campaign':
                return this._http.put(url, payload, this.emailTemplateOptions).pipe(map(res => res));
                break;
            case 'services':
                return this._http.put(url, payload, this.servicesOptions).pipe(map(res => res));
                break;
            case 'access':
                return this._http.put(url, payload, this.accessOptions).pipe(map(res => res));
                break;
            case 'dev-access':
                return this._http.put(url, payload, this.devAccessOptions).pipe(map(res => res));
                break;
            default:
                return this._http.put(url, payload, this.httpOptions).pipe(map(res => res));
                break;
        }
    }

    getItemsForUrl(url, httpOptions) {
        return this._http.get(environment.apihost + '/' + url, httpOptions).pipe(map(res => res)).catch((e: any) => Observable.throw(this.errorHandler(e)));
    }

    postItemForUrl(url, httpOptions, item): Observable<object> {
        return this._http.post(environment.apihost + '/' + url, item, httpOptions);
    }

    putItemForUrl(url, httpOptions, item): Observable<object> {
        return this._http.put(environment.apihost + '/' + url, item, httpOptions);
    }

    deleteItemForUrl(url, httpOptions) {
        return this._http.delete(environment.apihost + '/' + url, httpOptions);
    }

    getDevExItems(version, partner, account, entity) {
        if (partner === 'commons') {
            const commonsHttpOptions = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'pkey': '3fe18f9884ea832e3fede1e661740c4a',
                    'Access-Control-Allow-Origin': '*',
                    'observe': 'response'
                })
            };
            return this._http.get(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity, commonsHttpOptions).pipe(map(res => res));
        } else {
            this.httpOptions = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'pkey': localStorage.getItem('partnerKey'),
                    'Access-Control-Allow-Origin': '*'
                })
            };
            return this._http.get(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity, this.httpOptions).pipe(map(res => res));
        }

    }

    getItemsWithPkey(version, partner, account, entity, pkey) {
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': pkey,
                'Access-Control-Allow-Origin': '*'
            })
        };
        return this._http.get(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity, this.httpOptions).pipe(map(res => res));
    }

    getItemsByLanguage(version, partner, account, entity, language) {
        this.getHttp();
        if (partner === 'commons') {
            // const commonsHttpOptions = {
            //     headers: new HttpHeaders({
            //         'Content-Type': 'application/json',
            //         'pkey': '3fe18f9884ea832e3fede1e661740c4a',
            //         'Access-Control-Allow-Origin': '*',
            //         'observe': 'response'
            //     })
            // };
            return this._http.get(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity + '/lang/' + language, this.commonsHttpOptions).pipe(map(res => res));
        } else {
            // this.httpOptions = {
            //     headers: new HttpHeaders({
            //         'Content-Type': 'application/json',
            //         'pkey': localStorage.getItem('partnerKey'),
            //         'Access-Control-Allow-Origin': '*'
            //     })
            // };
            return this._http.get(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity + '/lang/' + language, this.adminHttpOptions).pipe(map(res => res));
        }

    }

    getItemsForOperation(version, partner, account, operation) {
        this.getHttp();
        return this._http.get(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/operations/' + operation, this.httpOptions).pipe(map(res => res));
    }

    getRowCountForApi(version, partner, account, entity) {
        return this._http.get(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity + '/count', this.httpOptions);
    }

    deleteItem(id: string, version, partner, account, entity) {
        this.getHttp();
        switch (partner) {
            case 'services':
                return this._http.delete(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity + '/' + id, this.servicesOptions).pipe(map(res => res));
                break;
            case 'access':
                return this._http.delete(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity + '/' + id, this.accessOptions).pipe(map(res => res));
                break;
            case 'dev-access':
                return this._http.delete(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity + '/' + id, this.devAccessOptions).pipe(map(res => res));
                break;
            default:
                return this._http.delete(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity + '/' + id, this.httpOptions);
                break;
        }
    }

    getItemById(id: string, version, partner, account, entity) {
        return this._http.get(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity + '/' + id, this.httpOptions);
    }

    getItemByIdWithNoDBRef(id: string, version, partner, account, entity) {
        return this._http.get(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity + '/' + id + '?dbref=false', this.httpOptions);
    }

    postItemUpdate(id: string, item, version, partner, account, entity): Observable<object> {
        return this._http.put(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity + '/' + id, item, this.httpOptions);
    }

    patchItemUpdate(id: string, item, version, partner, account, entity): Observable<object> {
        this.getHttp();
        if (account === 'services') {
            return this._http.patch(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity + '/' + id, item, this.servicesOptions)
                .pipe(map(res => res));
        } else if (account === 'access') {
            return this._http.patch(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity + '/' + id, item, this.accessOptions)
                .pipe(map(res => res));
        } else if (account === 'dev-access') {
            return this._http.patch(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity + '/' + id, item, this.devAccessOptions)
                .pipe(map(res => res));
        } else {
            return this._http.patch(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity + '/' + id, item, this.httpOptions)
                .pipe(map(res => res));
        }
    }

    addItem(item, version, partner, account, entity) {
        this.getHttp();
        switch (partner) {
            case 'services':
                return this._http.post(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity, item, this.servicesOptions);
                break;
            case 'access':
                return this._http.post(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity, item, this.accessOptions);
                break;
            case 'dev-access':
                return this._http.post(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity, item, this.devAccessOptions);
                break;
            default:
                return this._http.post(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity, item, this.httpOptions);
                break;
        }
    }

    addEmailTemplate(item, version, partner, account, entity) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': '3fe936d53cafa2913fbf2b31b9c0de60',
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };
        return this._http.post(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity, item, {
            observe: 'response',
            headers: httpOptions.headers
        });
    }

    updateEmailTemplate(item, version, partner, account, entity, id) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': '3fe936d53cafa2913fbf2b31b9c0de60',
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };
        return this._http.patch(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity + '/' + id, item, {
            observe: 'response',
            headers: httpOptions.headers
        });
    }

    deleteEmailTemplate(version, partner, account, entity, id) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': '3fe936d53cafa2913fbf2b31b9c0de60',
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };
        return this._http.delete(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity + '/' + id, {
            observe: 'response',
            headers: httpOptions.headers
        });
    }

    executeEmail(item, version, partner, account, entity) {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': '3fe936d53cafa2913fbf2b31b9c0de60',
                'Access-Control-Allow-Origin': '*',
                'observe': 'response'
            })
        };
        return this._http.post(environment.apihost + '/' + partner + '/' + account + '/' + version + '/' + entity, item, {
            observe: 'response',
            headers: httpOptions.headers
        });
    }

    // Authz Section
    // getPermissions(partner, account) {
    //     return this._http.get(environment.apihost + '/v1/' + partner + '/' + account + '/permissions', this.httpOptions).pipe(map(res => res));
    // }

    updateUsers(id, data) {
        const httpOptions = {
            headers: new HttpHeaders({
                'pkey': environment.accessPkey
            })
        };
        return this._http.patch(environment.accessHost + '/v1/users/' + id, data, httpOptions).pipe(map(res => res));
    }

    getUserWithId(id) {
        const httpOptions = {
            headers: new HttpHeaders({
                'pkey': environment.accessPkey
            })
        };
        return this._http.get(environment.accessHost + '/v1/users/' + id, httpOptions).pipe(map(res => res));
    }

    getPermissionGroupswithParams(partner, account, params) {
        return this._http.get(environment.apihost + '/v1/access/data/' + partner + '/' + account + '/permissiongroups?partner=' + params, this.httpOptions).pipe(map(res => res));
    }

    getPermissionsWithParams(partner, account, params) {
        return this._http.get(environment.apihost + '/v1/access/data/' + partner + '/' + account + '/permissions?partner=' + params, this.httpOptions).pipe(map(res => res));
    }

    getRolesWithParams(partner, account, params) {
        return this._http.get(environment.apihost + '/v1/access/data/' + partner + '/' + account + '/roles?partner=' + params, this.httpOptions).pipe(map(res => res));
    }

    getPermissionGroups(partner, account) {
        return this._http.get(environment.apihost + '/v1/access/data/' + partner + '/' + account + '/permissiongroups', this.httpOptions).pipe(map(res => res));
    }

    getPlatformPermissions(partner, account) {
        return this._http.get(environment.apihost + '/v1/access/data/' + partner + '/' + account + '/permissions', this.httpOptions).pipe(map(res => res));
    }

    getPermissionGroup(partner, account, id) {
        return this._http.get(environment.apihost + '/v1/' + partner + '/' + account + '/permissiongroups/' + id, this.httpOptions).pipe(map(res => res));
    }

    InsertPermissionGroup(partner, account, data) {
        //data --> access
        return this._http.post(environment.apihost + '/v1/access/data/' + partner + '/' + account + '/permissiongroups', data, this.httpOptions);
    }

    UpdatePermissionGroup(partner, account, data) {
        if (partner === 'access') {
            return this._http.patch(environment.apihost + '/v1/access/data/' + partner + '/' + account + '/permissiongroups', data, this.accessOptions)
                .pipe(map(res => res));
        } else if (partner === 'dev-access') {
            return this._http.patch(environment.apihost + '/v1/access/data/' + partner + '/' + account + '/permissiongroups', data, this.devAccessOptions)
                .pipe(map(res => res));
        }
    }

    deletePermissionGroup(partner, account, id) {
        return this._http.delete(environment.apihost + '/v1/access/data/' + partner + '/' + account + '/permissiongroups/' + id, this.httpOptions);
    }

    getRoles(partner, account) {
        return this._http.get(environment.apihost + '/v1/access/data/' + partner + '/' + account + '/roles', this.httpOptions).pipe(map(res => res));
    }

    getRole(partner, account, id) {
        return this._http.get(environment.apihost + '/v1/' + partner + '/' + account + '/roles/' + id, this.httpOptions).pipe(map(res => res));
    }

    InsertRole(data) {
        const httpOptions = {
            headers: new HttpHeaders({
                'pkey': environment.accessPkey
            })
        };
        return this._http.post(environment.accessHost + '/v1/roles', data, httpOptions).pipe(map(res => res));
    }

    UpdateRole(id, data) {
        const httpOptions = {
            headers: new HttpHeaders({
                'pkey': environment.accessPkey
            })
        };
        return this._http.patch(environment.accessHost + '/v1/roles/' + id, data, httpOptions).pipe(map(res => res));
    }

    deleteRole(partner, account, id) {
        return this._http.delete(environment.apihost + '/v1/' + partner + '/' + account + '/roles/' + id, this.httpOptions);
    }

    getUsers(partner, account) {
        return this._http.get(environment.apihost + '/v1/' + partner + '/' + account + '/users', this.httpOptions).pipe(map(res => res));
    }

    getUser(partner, account, id) {
        return this._http.get(environment.apihost + '/v1/' + partner + '/' + account + '/users/' + id, this.httpOptions).pipe(map(res => res));
    }

    InsertUser(partner, account, data) {
        return this._http.post(environment.apihost + '/v1/' + partner + '/' + account + '/users', data, this.httpOptions);
    }

    UpdateUser(partner, account, data) {
        return this._http.put(environment.apihost + '/v1/' + partner + '/' + account + '/users', data, this.httpOptions);
    }

    deleteUser(partner, account, id) {
        return this._http.delete(environment.apihost + '/v1/' + partner + '/' + account + '/users/' + id, this.httpOptions);
    }

    uploadTextToS3AndGetFileURL(partner, account, data) {
        return this._http.post(environment.apihost + '/v1/data/' + partner + '/' + account + '/createanduploadfiletopartneraccount', data, this.httpOptions);
    }

    // Audit Section
    postAuditItemDelete(version, partner, account, entity) {
        const updateApiAudit = {
            'account_id': account,
            'entityname': entity,
            'partner': partner,
            'version': version
        };
        const httpOpt = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': '3fee0e37fef58a553fddddb61efd53e4',
                'Access-Control-Allow-Origin': '*'
            })
        };
        return this._http.put(environment.apihost + '/' + 'v1' + '/data/' + 'billing' + '/' + 'billing' + '/' + 'PartnerApiAudit' + '/audit/delete', updateApiAudit, httpOpt);
    }

    addAuditItem(data, version, partner, account, entity) {
        const httpOpt = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': '3fee0e37fef58a553fddddb61efd53e4',
                'Access-Control-Allow-Origin': '*'
            })
        };
        return this._http.post(environment.apihost + '/' + 'v1' + '/data/' + 'billing' + '/' + 'billing' + '/' + 'PartnerApiAudit' + '/audit/add', data, httpOpt);
    }

    getFeatures() {
        const httpOpt = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': '3fee0e37fef58a553fddddb61efd53e4',
                'Access-Control-Allow-Origin': '*'
            })
        };
        return this._http.get<any[]>(environment.apihost + '/' + 'v1' + '/admin/' + 'billing' + '/' + 'billing' + '/' + 'Features' + '/plans/features', httpOpt);
    }

    getPlans() {
        const httpOpt = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'pkey': '3fee0e37fef58a553fddddb61efd53e4',
                'Access-Control-Allow-Origin': '*'
            })
        };
        return this._http.get<any[]>(environment.apihost + '/' + 'v1' + '/admin/' + 'billing' + '/' + 'billing' + '/' + 'Plans' + '/IN/plans', httpOpt);
    }

    saveItems(version, partner, account, entity, data): Observable<object> {
        return this._http.post(environment.apihost + '/' + version + '/data/' + partner + '/' + account + '/' + entity + '/bulkinsert', data, this.httpOptions);
    }

}
